// UserContext.js
import React, { createContext, useState, useEffect } from "react";
import { getApiUrl } from "../../utils/apiUrl";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState({
    id: "",
    name: "",
    roles: [],
    isLoading: true,
  });

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const response = await fetch(
          getApiUrl("api/current_user/"),
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            credentials: "include",
          },
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }

        setUserInfo({
          ...data,
          roles: data.roles || [],
          isLoading: false,
        });
      } catch (error) {
        console.error("Error fetching user details:", error);

        setUserInfo({
          id: "",
          image: null,
          name: "",
          roles: [],
          isLoading: false,
        });
      }
    };

    fetchUserInfo();
  }, []);

  return (
    <UserContext.Provider value={userInfo}>{children}</UserContext.Provider>
  );
};
